<!-- =========================================================================================
    File Name: TableLeads.vue
    Description: Tabella dei Leads
========================================================================================== -->
<template>
  <div>
    <!-- <search-bar @create="newLead" @find="cercaLead" :p="{current:this.page, tot:this.tot_page}" :filter_list="['Tutti','Qualifica','In corso di decisione','Passaggio alle vendite','In attesa di vendita','Soddisfatto','Non Soddisfatto']" :newTexts="['Nuovo']" tooltip="Responsabile, Fabbisogno"></search-bar> -->
    <search-bar @create="newLead" @find="cercaLead" :filter_list="['Tutti','Qualifica','In corso di decisione','Passaggio alle vendite','In attesa di vendita','Soddisfatto','Non Soddisfatto']" :newTexts="['Nuovo']" tooltip="Fabbisogno, Contatto/Azienda, Responsabile"></search-bar>
    <!-- <bar-lead @find="cercaLead" :filter_list="['Tutti','Qualifica','In corso di decisione','Passaggio alle vendite','In attesa di vendita','Soddisfatto','Non Soddisfatto']" ></bar-lead>
      <vs-table :pagination="getLeads(board).length >= 10" v-if="board && getLeads(board).length > 0" :max-items="10" v-model="selected" @selected="showLead" :data="getLeads(board)"> -->
      <vs-table :pagination="leads.length >= 10" v-if="leads.length > 0" :max-items="10" v-model="selected" @selected="showLead" :data="leads">
        <template slot="thead">
            <vs-th>Fabbisogno Cliente</vs-th>
            <vs-th>Tipo</vs-th>
            <vs-th>Stato</vs-th>
            <vs-th>Contatto / Azienda</vs-th>
            <vs-th v-if="$acl.check('responsabile')">Responsabile</vs-th>
            <vs-th>Completato</vs-th>
            <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].nome" >
                {{data[indextr].nome}}
            </vs-td>

            <vs-td :data="[data[indextr].azienda, data[indextr].contatto]">
              <vx-tooltip v-if="data[indextr].azienda" text="Azienda" position="top">
                <vs-button class="no-pointer-event inline-block p-1" type="flat" icon-pack="feather" icon="icon-grid"></vs-button>
              </vx-tooltip>

              <vx-tooltip v-else-if="data[indextr].contatto" text="Contatto" position="left">
                <vs-button icon-pack="feather" icon="icon-phone-call" class="no-pointer-event inline-block p-1" type="flat" ></vs-button>
              </vx-tooltip>
            </vs-td>

            <vs-td :data="data[indextr].stato.nome">
                {{data[indextr].stato.nome}}
            </vs-td>

            <vs-td :data="[data[indextr].azienda, data[indextr].contatto]">
                {{data[indextr].azienda ? data[indextr].azienda.ragione_sociale : `${data[indextr].contatto.nome} ${data[indextr].contatto.cognome}`}}
            </vs-td>

            <vs-td v-if="data[indextr].responsabile" :data="data[indextr].responsabile">
                {{[data[indextr].responsabile.cognome,data[indextr].responsabile.nome].join(' ')}}
            </vs-td>

            <vs-td :data="data[indextr].completato">
                {{(data[indextr].stato.nome == 'Soddisfatto' || data[indextr].stato.nome == 'Non Soddisfatto')
                  ? formatDate(new Date(data[indextr].stati[data[indextr].stati.length-1].data)) : ''}}
            </vs-td>

            <vs-td>
              <vs-row vs-justify="flex-end" class="mr-5">
                <vx-tooltip text="Modifica">
                  <vs-button @click="openLead(data[indextr], $event)" radius color="warning" type="line" size="small" icon-pack="feather" icon="icon-edit"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Cambio Stato">
                  <vs-button @click="open_stato(data[indextr], $event)" class="ml-2" radius color="success" size="small" type="line" icon-pack="feather" icon="icon-cloud-lightning"></vs-button>
                </vx-tooltip>
              </vs-row>
            </vs-td>

            <vs-popup :key="Math.random()" class="holamundo text-center" title="CAMBIA STATO LEAD" :active.sync="popupStato">
              <p class="mb-3">
                Scegliere lo stato a cui portare il Lead
              </p>
              <vs-row class="m-3">
                <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
                  <vs-select class="mb-3" v-model="avanza_stato">
                    <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in stati.filter(s=>s != tr_.status)" />
                  </vs-select>
                </vs-col>
              </vs-row>
              <vs-divider />
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-button @click="commitStato(tr_)" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
              </vs-col>
            </vs-popup>
          </vs-tr>
        </template>
    </vs-table>
    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-aziende" spacer v-model="isSidebarActive">
      <sidebar-form-lead @close-me="sidebarClose" @elimina-lead="handleEliminaLead" :id_stato="this.id_stato" :id_az="this.target.id_az" :id_cont="this.target.id_cont" @lead-salvato="handleSave" v-if="sidebar_type === 'form-lead'" :key="formkey" :selected="selected_lead"></sidebar-form-lead>
      <sidebar-lead @close-me="sidebarClose" v-else-if="sidebar_type === 'show-lead' && selected" :key="formkey" :selected="selected"></sidebar-lead>
    </vs-sidebar>
  </div>
</template>

<script>
import axios from 'axios'
import SidebarFormLead from './SidebarFormLead.vue'
import SidebarLead from './SidebarLead.vue'
import SearchBar from '../commons/SearchBar.vue'
import {StarRating} from 'vue-rate-it';

export default{
  data () {
    return {
      stati: [],
      leads: [],

      // tr_: { stato: {} },
      tr_: { stato: {} },
      popupStato: false,
      avanza_stato: "null",

      haveSaved: false,
      selected_stato: null,
      selected_lead: null,
      sidebar_type: '',
      sidebar_active: false,
      board: null,

      keyword: "",
      selected: null,

      utente_nome: "",
      utente_id: "",

      id_sinistro: null,
      id_destro: null,

      id_stato: null,
      id_lead: null,

      boardkey: Math.random(),

      icon: {
        Telefonata: 'icon-phone-call',
        Mail: 'icon-mail',
        Appuntamento: 'icon-calendar'
      },

      target: {
        id_az: null,
        id_cont: null,
      },
    }
  },
  props: {
    radio_tab: String
  },
  mounted() {
    if (localStorage.utente_nome) {
      this.utente_nome = localStorage.utente_nome
    }
    if (localStorage.utente_id) {
      this.utente_id = localStorage.utente_id
    }
    if (this.$route.params.cont_id) {
      this.target.id_cont = this.$route.params.cont_id
      setTimeout(() => this.handleNewLead(), 500)
    }
    if (this.$route.params.az_id) {
      this.target.id_az = this.$route.params.az_id
      setTimeout(() => this.handleNewLead(), 500)
    }
    if (this.$route.params.type) {
      setTimeout(() => this.handleNewLead(), 500)
    }
    this.getBoard()
    this.newGetLeads()
  },
  components: {
    SidebarFormLead,
    SidebarLead,
    StarRating,
    SearchBar,
  },
  methods: {
    newGetLeads() {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/many_leads', {
        option: this.option ? this.option : "Tutti",
        keyword: this.keyword,
      }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(response => {
        this.leads = response.data
        if (this.$route.params.wanted_id) {
          this.selected = this.leads.find( l => {
            if (l.id == this.$route.params.wanted_id) return l
          })
          this.showLead()
        }
        this.$vs.loading.close()
      }).catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
    },
    cercaLead(k,opt) {
      this.keyword = k
      this.option = opt
      // this.getBoard()
      this.newGetLeads()
    },
    filterData(d) {
      return d.filter( lead => (lead.id_azienda || lead.id_contatto) )
    },
    formatDate(date) {
      var options = { year: "numeric", month: "short", day: "numeric" }
      return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
    },
    getLeads(board) {
      let a = board.stati.map(e => {
        let obj = e.leads
        obj = obj.map(o => {
          let obj2 = o
          obj2.stato = {nome: e.nome}
          return obj2
        })
        return obj
      })

      return this.filterData([].concat.apply([], a))
    },
    showLead() {
      this.sidebar_type = 'show-lead'
      // this.id_lead = null
      // this.selected_lead = lead
      this.formkey = Math.random()
      this.sidebar_active = !this.sidebar_active
    },
    canEditBoard(board) {
      return +this.utente_id === +board.creatore.id
              || this.$acl.check('admin')
    },
    canEdit(lead) {
      return +this.utente_id === +lead.creatore.id
              || (lead.responsabile && +this.utente_id === +lead.responsabile.id)
              || this.$acl.check('admin')
    },
    updateBlock(id, status) {
      if(this.canEdit(this.leads.find(e => e.id == id))) {
        axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/modifica', { id: +id, id_stato: this.board.stati.find(e => e.nome == status)['id'] }, {
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true
        })
        .then( () => {
          this.getBoard()
          this.newGetLeads()
        })
        .catch(e => {
          console.error(e)
          this.getBoard()
          this.newGetLeads()
        })
      }
      else {
        this.boardkey = Math.random()
        this.getBoard()
        this.newGetLeads()
      }
    },
    // newLeft(s) {
    //   this.id_destro = this.board.stati.find(e => e.nome == s)['id']
    //   this.id_sinistro = this.board.stati.find(e => e.nome == s)['id_sinistro']
    //   this.handleNewStato()
    // },
    // newRight(s) {
    //   this.id_sinistro = this.board.stati.find(e => e.nome == s)['id']
    //   this.id_destro = this.board.stati.find(e => e.nome == s)['id_destro']
    //   this.handleNewStato()
    // },
    // drop(s) {
    //   axios.post(process.env.VUE_APP_BACKEND_API+'/board/stato/elimina', { id: this.board.stati.find(e => e.nome == s)['id'] }, {
    //     headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
    //     withCredentials: true
    //   })
    //   .then( () => this.getBoard() )
    //   .catch(e => console.log(e))
    // },
    newLead() {
      this.id_stato = this.board.stati.find(e => e.nome == 'Qualifica')['id']
      this.handleNewLead()
    },
    openLead(l, ev) {
      ev.stopPropagation()
      this.sidebar_type = 'form-lead'
      this.formkey = Math.random()
      this.selected_stato = null
      this.id_stato = l.stato.id
      this.selected_lead = l
      this.sidebar_active = !this.sidebar_active
    },
    handleNewLead() {
      this.sidebar_type = 'form-lead'
      this.formkey = Math.random()
      this.selected_stato = null
      this.selected_lead = null
      this.sidebar_active = !this.sidebar_active
    },
    handleSave() {
      this.isSidebarActive = !this.sidebar_active
      this.haveSaved = true
      this.formkey = Math.random()
      this.selected = null
      this.selected_stato = null
      this.selected_lead = null
      this.getBoard()
      this.newGetLeads()
    },
    getBoard() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/board', {
        option: this.option ? this.option : "Tutti",
      }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      }).then(response => {
        this.board = response.data
        this.stati = []
        // this.leads = []
        let f = response.data.stati.find(e => !e.id_sinistro)
        this.id_stato = f.id
        while(f) {
          this.stati.push(f.nome)
          f = response.data.stati.find(e => e.id == f.id_destro)
        }
        response.data.stati.forEach(e => {
          e.leads.forEach(x => {
            x.status = e.nome
            if (x.id_azienda || x.id_contatto) {
              // this.leads.push(x)
            }
          })
        })
      }).catch(e => {
        console.log(e)
      })
    },
    handleEliminaLead() {
      this.sidebar_active = !this.sidebar_active
      this.boardkey = Math.random()
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/elimina', { id: this.selected_lead.id },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        })
        .then(response => {
          this.message = response.data
          this.selected = null
          this.haveSaved = true
          this.getBoard()
          this.newGetLeads()
        })
        .catch(e => console.log(e))
    },
    getColorScadenza(scadenza) {
      let color = ""
      let now = new Date()
      if (new Date(scadenza)<now) {
        color = "red"
      } else if (new Date(scadenza)<1) {
        color = "orange"
      } else {
        color = "green"
      }
      return color
    },
    open_stato(lead,ev) {
      ev.stopPropagation()
      this.tr_ = lead
      this.popupStato = true
    },
    commitStato(lead) {
      let current_stato = this.board.stati.find(e => e.nome == this.avanza_stato)
      axios.post(process.env.VUE_APP_BACKEND_API+'/board/lead/modifica', { id: lead.id, id_stato: current_stato['id'] }, {
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      })
      .then( () => {
        this.avanza_stato = null
        this.tr_ = { stato: {} }
        this.popupStato = false
        this.getBoard()
        this.newGetLeads()
      })
      .catch(e => {
        console.error(e)
        this.getBoard()
        this.newGetLeads()
      })
    },
    sidebarClose() {
      this.sidebar_active = false
      this.selected = null
    }
  },
  computed: {
    isSidebarActive: {
      get() {
        return this.sidebar_active
      },
      set(val) {
        if(!val && this.haveSaved) {
          this.haveSaved = false
        }
        else {
          this.sidebar_active = val
        }
      }
    }
  }
}
</script>
